import * as React from "react";
import { CgSpinner } from "react-icons/cg";
import { Transition } from "@headlessui/react";
export default function RouteLoading() {
    var _a = React.useState(false), showSpinner = _a[0], setShouldShowSpinner = _a[1];
    React.useEffect(function () {
        var timeout = window.setTimeout(function () {
            setShouldShowSpinner(true);
        }, 500);
        return function () {
            window.clearTimeout(timeout);
        };
    }, []);
    return (React.createElement(Transition, { show: showSpinner, enterFrom: "opacity-0", enterTo: "opacity-100", enter: "transition-opacity" },
        React.createElement("div", { className: "flex w-full grow items-center justify-center" },
            React.createElement("div", { className: "h-16 w-16" },
                React.createElement(CgSpinner, { className: "h-16 w-16 animate-spin", color: "#555" })))));
}
